import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Seo from './Seo';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
export default function App() {
  return <HelmetProvider data-id="element-0">
      <Seo data-id="element-1" />
      <div className="font-sans antialiased text-gray-900" data-id="element-2">
        <Header data-id="element-3" />
        <main data-id="element-4">
          <div className="scroll-mt-24" data-id="element-5">
            <Hero data-id="element-6" />
          </div>
          <div id="features" className="scroll-mt-24" data-id="element-7">
            <Features data-id="element-8" />
          </div>
          <div id="como-funciona" className="scroll-mt-24" data-id="element-9">
            <Process data-id="element-10" />
          </div>
          <div id="testimonials" className="scroll-mt-24" data-id="element-11">
            <Testimonials data-id="element-12" />
          </div>
          <div id="pricing" className="scroll-mt-24" data-id="element-13">
            <CTA data-id="element-14" />
          </div>
        </main>
        <Footer data-id="element-15" />
        <WhatsAppFloat phone="56953590090" message="Hola, quiero vender mi propiedad con tarifa fija." data-id="element-16" />
      </div>
    </HelmetProvider>;
}